





































import { Component, Vue } from 'vue-property-decorator'
import ValuationStepper, { StepResult } from '@/components/Controls/Valuation/ValuationStepper.vue'
import ValuationStep from '@/components/Controls/Valuation/ValuationStep.vue'
import AddressDetails from '@/components/Controls/Valuation/AddressDetails.vue'
import AssessmentDetails from '@/components/Controls/Valuation/AssessmentDetails.vue'
import PropertyClassification from '@/components/Controls/Valuation/PropertyClassification.vue'
import ContactDetails from '@/components/Controls/Valuation/ContactDetails.vue'
import PropertyDetails from '@/components/Controls/Valuation/PropertyDetails.vue'
import PhotosAndDocuments from '@/components/Controls/Valuation/PhotosAndDocuments.vue'
import Payment from '@/components/Controls/Valuation/Payment.vue'
import { Services } from 'truemarket-modules/src/services'

@Component({
  components: {
    ValuationStepper,
    ValuationStep,
    AddressDetails,
    AssessmentDetails,
    PropertyClassification,
    ContactDetails,
    PropertyDetails,
    PhotosAndDocuments,
    Payment
  }
})
export default class New extends Vue {
  public steps: string[] = [
    'Address', 'Assessment Details', 'Property Classification',
    'Your Details', 'Property Details', 'Photos & Documents', 'Payment'
  ]

  public stepKeys: string[] = [
    'AddressDetails', 'AssessmentDetails', 'PropertyClassification',
    'ContactDetails', 'PropertyDetails', 'PhotosAndDocuments', 'Payment'
  ]

  async created () {
    await this.initialiseValuation()
  }

  async initialiseValuation () {
    const params = new URLSearchParams(window.location.search)

    // Existing/resumed valuation link. Set this before the valuation
    // step components are mounted so they can resume normally.
    const tempValuationId = params.get('tempValuationId')

    if (tempValuationId) {
      this.tempValuationId = tempValuationId
      this.initialised = true
      return
    }

    // BGL entry point. Send the original BGL query string to our API,
    // which will create or locate the corresponding TempValuation.
    const callbackId = params.get('callbackId')

    if (!callbackId) {
      this.initialised = true
      return
    }

    try {
      const result = await Services.API.ValuationForm.InitialiseBglValuation(
        params.toString()
      )

      if (!result || !result.TempValuationId) {
        throw new Error('TempValuationId was not returned')
      }

      this.tempValuationId = result.TempValuationId

      // Once BGL has been resolved to an internal TempValuationId, keep
      // the browser URL small and allow refreshes to follow the normal
      // resume flow above.
      await this.$router.replace({
        path: '/valuation',
        query: {
          tempValuationId: result.TempValuationId,
          source: 'bgl'
        }
      })
    } catch (ex) {
      console.error(
        'Unable to initialise BGL valuation',
        ex
      )
    } finally {
      this.initialised = true
    }
  }

  resumedHandler (id: string) {
    this.tempValuationId = id
  }

  stepSubmitted (e: StepResult) {
    if (e.stepName === 'AddressDetails') {
      this.tempValuationId = e.response.TempValuationId
    }

    if (e.stepName === 'AssessmentDetails') {
      this.purpose = e.data.Purpose
    }

    if (e.stepName === 'PropertyClassification') {
      this.propertyType = e.data.PropertyType
      this.propertyClassification = e.data.PropertyClassification
    }
  }

  initialised = false

  tempValuationId: string | null = null

  purpose: string | null = null

  propertyType: string | null = null
  propertyClassification: string | null = null
}
